/**
 * Clears all search params and replaces them with the new ones
 */
export function clearHistorySearchParams() {
    replaceHistorySearchParams(undefined);
}
/**
 * Updates search parameters with existing ones.
 *
 * @params params - Key-value pairs of search params to merge with the existing
 * parameters.
 */
export function updateSearchParams(params = {}, options = {}) {
    const url = new URL(window.location.href);
    // Any values set to 'undefined' will be removed from search parameters.
    for (const [key, val] of Object.entries(params)) {
        if (typeof val === 'undefined') {
            url.searchParams.delete(key);
        }
        else {
            url.searchParams.set(key, val);
        }
    }
    writeHistorySearchParams(Object.fromEntries(url.searchParams), options.mode ?? 'replace');
}
/**
 * Clears all search params and replaces them with the new ones
 * @param params - key-value pairs of search params to replace. If undefined, all search params will be cleared.
 */
export function replaceHistorySearchParams(params) {
    writeHistorySearchParams(params, 'replace');
}
/**
 * Parses a comma-separated multi-select search param: unknown values are
 * dropped and the result follows the allowlist's order.
 */
export function parseFilterKeysSearchParam(value, allKeys) {
    if (!value)
        return [];
    const requestedKeys = value.split(',');
    return allKeys.filter((key) => requestedKeys.includes(key));
}
/**
 * Inverse of {@link parseFilterKeysSearchParam}; an empty selection
 * serializes to undefined so the param is removed.
 */
export function serializeFilterKeysSearchParam(keys) {
    if (keys.length === 0)
        return undefined;
    return keys.join(',');
}
function writeHistorySearchParams(params, mode) {
    const url = new URL(window.location.href);
    const searchParams = params ? new URLSearchParams(params) : new URLSearchParams();
    const newParams = searchParams.toString();
    if (newParams !== url.searchParams.toString()) {
        const nextPath = `${url.pathname}${newParams ? `?${newParams}` : ''}${url.hash}`;
        if (mode === 'push') {
            // ast-grep-ignore: no-window-history-pushState
            window.history.pushState({}, '', nextPath);
            return;
        }
        // ast-grep-ignore: no-window-history-replaceState
        window.history.replaceState({}, '', nextPath);
    }
}
//# sourceMappingURL=historySearchParams.js.map